import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    Text,
    Spacer
} from '..';

export default class AccountId extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({ show: !this.state.show });
    }

    render() {
        const {
            hideLabel,
            id,
            showLabel
        } = this.props;

        return (
            <Spacer className="acct-id__root" top={20}>
                <button
                    className="acct-id__btn"
                    onClick={this.toggle}
                >
                    <span className={this.state.show ? 'acct-id__icon acct-id__icon--show' : 'acct-id__icon'} />
                    {this.state.show ? hideLabel : showLabel}
                </button>

                {this.state.show
                    ? <Text as="div" className="acct-id__id" size={14}>{id}</Text>
                    : null
                }
            </Spacer>
        );
    }
}

AccountId.propTypes = {
    hideLabel: PropTypes.string,
    id: PropTypes.string,
    showLabel: PropTypes.string
};
